<template>
  <div>
    <div class="bg-mountain mask-bottom">
      <div class="container py-5">
        <div class="text-center text-white py-5">
          <h1 class="pt-md-5">Походы</h1>
          <p>Новый раздел нашего сайта, где вы можете просмотреть информацию о различных походах, добавить свой поход или создать новый маршрут. Готовьтесь к новым приключениям и исследуйте мир вместе с нами!</p>
          <hr class="space space-xs">
        </div>
      </div>
    </div>
    <hr class="space space-xs">
    <div class="container">      
      <hr class="space space-xs">

      <div class="d-flex align-items-center">
        <h3 class="mb-3">🏔️ Мои походы <span v-if="orderedMyHikes">({{ orderedMyHikes.length }})</span></h3>
        <router-link v-if="myHikes && myHikes.length > 0" class="btn btn-primary mb-3 ml-3" :to="{ name: 'hike-add' }">Добавить поход</router-link>
      </div>
      <div class="card bg-light mb-3" v-if="!isMyHikesLoading && myHikes && myHikes.length < 1">
        <div class="card-body">
          <h4>Добавьте свой первый поход:</h4>
          <p >Начните путешествовать и наслаждаться красотами природы, добавьте свой первый поход в нашу базу данных. Перейдите на страницу "Добавить поход" и заполните информацию. Помогите другим людям выбрать место для путешествия, поделитесь своим опытом!</p>
          <a class="btn btn-primary" href="/hikes/add">Добавить поход</a>
        </div>
      </div>
      <loader v-if="isMyHikesLoading"></loader>

      <div v-else class="row">
        <div v-for="hike in orderedMyHikes" :key="hike.id" class="col-md-4 mb-4">
          <hike :hike="hike" @delete="confirmDeleteHike" :showActionButtons="true"></hike>
        </div>
      </div>
      <hr class="space space-sm">
      <chat></chat>
      <hr class="space space-sm">
      <h3 class="mb-3">🏔️ Все походы <span v-if="orderedHikes">({{ orderedHikes.length }})</span></h3>
      <loader v-if="isHikesLoading"></loader>
      <div v-else class="row">
        <div v-for="hike in orderedHikes" :key="hike.id" class="col-md-4 mb-5">
          <hike-new :hike="hike"></hike-new>
        </div>
      </div>
    </div>
    <div class="modal" tabindex="-1" role="dialog" ref="deleteHikeModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Удалить поход</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="deletingHikeId = null">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Вы уверены, что хотите удалить этот поход?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="deletingHikeId = null; hideDeleteHikeModal();">Отмена</button>
            <button type="button" class="btn btn-danger" @click="deleteHike">Удалить</button>
          </div>
        </div>
      </div>
    </div>
    <hr class="space">
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

import Hike from './Includes/Hike'
import HikeNew from './Includes/HikeNew'
import Chat from '../Chat/Chat'

export default {
  name: 'hikes',
  components: {
    hike: Hike,
    hikeNew: HikeNew,
    chat: Chat
  },
  data () {
    return {
      deletingHikeId: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      hikes: state => state.hikes.hikes,
      myHikes: state => state.hikes.myHikes,
      isHikesLoading: state => state.hikes.isHikesLoading,
      isMyHikesLoading: state => state.hikes.isMyHikesLoading
    }),
    orderedHikes () {
      return this.hikes.sort((a, b) => {
        if (a.title < b.title) {
          return -1
        }
        if (a.title > b.title) {
          return 1
        }
        return 0
      })
    },
    orderedMyHikes () {
      return this.myHikes.sort((a, b) => {
        if (a.title < b.title) {
          return -1
        }
        if (a.title > b.title) {
          return 1
        }
        return 0
      })
    }
  },
  methods: {
    ...mapActions({
      deleteHikeAction: 'DELETE_HIKE'
    }),
    confirmDeleteHike (id) {
      this.deletingHikeId = id
      this.$refs.deleteHikeModal.classList.add('show')
      this.$refs.deleteHikeModal.style.display = 'block'
    },
    deleteHike () {
      if (this.deletingHikeId) {
        this.deleteHikeAction(this.deletingHikeId).then(() => {
          this.$refs.deleteHikeModal.classList.remove('show')
          this.$refs.deleteHikeModal.style.display = 'none'
        })
        this.hideDeleteHikeModal()
        this.deletingHikeId = null
      }
    },
    hideDeleteHikeModal () {
      this.$refs.deleteHikeModal.classList.remove('show')
      this.$refs.deleteHikeModal.style.display = 'none'
    }
  },
  mounted () {
    if (this.user && this.user.id) {
      this.$store.dispatch('GET_MY_HIKES', this.user.id)
    } else if (this.user && this.user.uid) {
      this.$store.dispatch('GET_MY_HIKES', this.user.uid)
    }
  },
  created () {
    this.$store.dispatch('GET_HIKES')
  }
}
</script>